export default __webpack_public_path__ + "static/media/skip4NowIcon.8820f255.png";